module.exports = __webpack_public_path__ + "static/media/postgresqlImg.688e03c9.png";